import { render, staticRenderFns } from "./Zingala.vue?vue&type=template&id=601cb15d"
import script from "./Zingala.vue?vue&type=script&lang=js"
export * from "./Zingala.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports